// 분리된 서비스들을 통합하는 메인 파일
import { cartCrudService } from './cart-crud.service';
import { cartItemsService } from './cart-items.service';
import { cartStockService } from './cart-stock.service';

// 타입 정의를 re-export
export type { 
  Cart,
  CartItem,
  CartServiceResponse,
  AddToCartResponse,
  StockValidationResponse,
  FindOfferResponse,
  OrderType
} from './cart.types';

class CartService {
  
  // CRUD methods - 기본 장바구니 관리
  async getCurrentCart(userId?: string, sessionId?: string) {
    return await cartCrudService.getCurrentCart(userId, sessionId);
  }

  async createCart(restaurantId: string, userId?: string, sessionId?: string) {
    return await cartCrudService.createCart(restaurantId, userId, sessionId);
  }

  async clearCart(cartId: string) {
    return await cartCrudService.clearCart(cartId);
  }

  async clearCartForRestaurantChange(userId?: string, sessionId?: string) {
    return await cartCrudService.clearCartForRestaurantChange(userId, sessionId);
  }

  async restoreCartOnPaymentFailure(cartId: string, orderType?: string) {
    const restoreResult = await cartCrudService.restoreCartOnPaymentFailure(cartId);
    
    if (restoreResult.success && orderType) {
      // 재고 복구 (예약할인 제외)
      const stockRestoreResult = await cartStockService.restoreCartStock(cartId, orderType as any);
      if (!stockRestoreResult.success) {
        console.error('Error restoring stock during cart recovery:', stockRestoreResult.error);
        // 재고 복구 실패해도 장바구니는 복원 (사용자가 다시 주문 시도할 수 있도록)
      }
    }
    
    return restoreResult;
  }

  async getCartTotal(cartId: string) {
    return await cartCrudService.getCartTotal(cartId);
  }

  // Items methods - 장바구니 아이템 관리
  async addToCart(
    productId: string, 
    offerId: string, 
    quantity: number, 
    userId?: string, 
    sessionId?: string
  ) {
    return await cartItemsService.addToCart(productId, offerId, quantity, userId, sessionId);
  }

  async removeFromCart(cartItemId: string) {
    return await cartItemsService.removeFromCart(cartItemId);
  }

  async updateCartItemQuantity(cartItemId: string, newQuantity: number) {
    return await cartItemsService.updateCartItemQuantity(cartItemId, newQuantity);
  }

  async findOfferByType(productId: string, orderType: any) {
    return await cartItemsService.findOfferByType(productId, orderType);
  }

  // Stock methods - 재고 관리
  async consumeCartStock(cartId: string, orderType?: string) {
    return await cartStockService.consumeCartStock(cartId, orderType as any);
  }

  async restoreCartStock(cartId: string, orderType?: string) {
    return await cartStockService.restoreCartStock(cartId, orderType as any);
  }

  async validateCartStock(cartId: string) {
    return await cartStockService.validateCartStock(cartId);
  }

}

export const cartService = new CartService();